/** @format */

export enum ProductReviewSliderType {
	LEFT = 'Left',
	NONE = 'None',
	RIGHT = 'Right'
}
